@if (authService.currentUser$ | async; as currUser) {
  <div class="master d-flex flex-column position-absolute">
    @if (!isRightMenuCollapsed) {
      <div class="right-menu-overlay" (click)="toggleRightMenu(false)"></div>
    }

    <mat-sidenav-container
      class="h-100 w-100"
      [hasBackdrop]="false"
      [ngClass]="{
        'left-menu-collapsed': isLeftMenuCollapsed,
        'right-menu-collapsed': isRightMenuCollapsed,
      }"
    >
      <mat-sidenav
        class="sidenav-left shadow-lg border-0 d-flex flex-column"
        [autoFocus]="false"
        [mode]="'side'"
        [opened]="true"
      >
        <div class="sidenav-full" id="sidenav-left">
          <div class="d-flex m-0 vh-100 flex-column overflow-hidden">
            <div class="sidenav-left__toggle flex-grow-0 py-3 px-4" (click)="toggleLeftMenu()">
              @if (isLeftMenuCollapsed) {
                <button mat-icon-button class="d-flex">
                  <img src="assets/images/logos/eagle.svg" />
                </button>
              } @else {
                <img class="sidenav-left__toggle__logo" src="assets/images/logos/eagle-wrap.svg" />
              }
            </div>

            <div class="sidenav-left__content flex-grow-1 overflow-auto">
              <a
                class="menu-item"
                matRipple
                [matRippleUnbounded]="true"
                [matRippleCentered]="true"
                id="sidenav-left-inflow-generator"
                [matTooltip]="'INFLOW_GENERATOR.TITLE' | translate"
                [matTooltipPosition]="'right'"
                [matTooltipDisabled]="!isLeftMenuCollapsed"
                [routerLink]="['/inflow-generator']"
                [routerLinkActive]="'active'"
              >
                <div class="menu-item__content">
                  <mat-icon class="i20 menu-item__content__icon">euro_symbol</mat-icon>
                  <span
                    class="menu-item__content__label"
                    [translate]="'INFLOW_GENERATOR.TITLE'"
                  ></span>
                </div>
              </a>

              <a
                class="menu-item"
                matRipple
                [matRippleUnbounded]="true"
                [matRippleCentered]="true"
                id="sidenav-left-candidate-leads"
                [matTooltip]="'CANDIDATE_LEADS.PLURAL' | translate"
                [matTooltipPosition]="'right'"
                [matTooltipDisabled]="!isLeftMenuCollapsed"
                [routerLink]="['/candidate-leads/']"
                [routerLinkActive]="'active'"
              >
                <div class="menu-item__content">
                  <mat-icon class="i20 menu-item__content__icon">person_search</mat-icon>
                  <span
                    class="menu-item__content__label"
                    [translate]="'CANDIDATE_LEADS.PLURAL'"
                  ></span>
                </div>
              </a>

              <a
                class="menu-item"
                matRipple
                [matRippleUnbounded]="true"
                [matRippleCentered]="true"
                id="matching-list"
                [matTooltip]="'MATCHING_LIST.MATCHING_LIST' | translate"
                [matTooltipPosition]="'right'"
                [matTooltipDisabled]="!isLeftMenuCollapsed"
                [routerLink]="['/matching-list/']"
                [routerLinkActive]="'active'"
              >
                <div class="menu-item__content">
                  <mat-icon class="i20 menu-item__content__icon">shopping_cart</mat-icon>
                  <span
                    class="menu-item__content__label"
                    [translate]="'MATCHING_LIST.MATCHING_LIST'"
                  ></span>
                </div>
              </a>

              <a
                class="menu-item"
                matRipple
                [matRippleUnbounded]="true"
                [matRippleCentered]="true"
                id="vacancy-applications-list"
                [routerLink]="['/vacancy-applications-list/']"
                [routerLinkActive]="'active'"
                [matTooltip]="'VACANCY_APPLICATIONS.TITLE' | translate"
                [matTooltipPosition]="'right'"
                [matTooltipDisabled]="!isLeftMenuCollapsed"
              >
                <div class="menu-item__content">
                  <mat-icon class="i20 menu-item__content__icon">email</mat-icon>
                  <span
                    class="menu-item__content__label"
                    [translate]="'VACANCY_APPLICATIONS.TITLE'"
                  ></span>
                </div>
              </a>

              <a
                class="menu-item"
                matRipple
                [matRippleUnbounded]="true"
                [matRippleCentered]="true"
                id="sidenav-left-leads"
                [matTooltip]="'LEADS.PROSPECTION' | translate"
                [matTooltipPosition]="'right'"
                [matTooltipDisabled]="!isLeftMenuCollapsed"
                [queryParamsHandling]="'preserve'"
                [routerLink]="['/leads/']"
                [routerLinkActive]="'active'"
              >
                <div class="menu-item__content">
                  <mat-icon class="i20 menu-item__content__icon">check_box</mat-icon>
                  <span class="menu-item__content__label" [translate]="'LEADS.PROSPECTION'"></span>
                </div>
              </a>

              <mat-divider class="my-2"></mat-divider>

              <a
                class="menu-item"
                matRipple
                [matRippleUnbounded]="true"
                [matRippleCentered]="true"
                id="sidenav-left-employees"
                [matTooltip]="'EMPLOYEE.PLURAL' | translate"
                [matTooltipPosition]="'right'"
                [matTooltipDisabled]="!isLeftMenuCollapsed"
                [queryParamsHandling]="'preserve'"
                [routerLink]="['/employees/']"
                [routerLinkActive]="'active'"
              >
                <div class="menu-item__content">
                  <mat-icon class="i20 menu-item__content__icon">people</mat-icon>
                  <span class="menu-item__content__label" [translate]="'EMPLOYEE.PLURAL'"></span>
                </div>
              </a>

              <a
                class="menu-item"
                matRipple
                [matRippleUnbounded]="true"
                [matRippleCentered]="true"
                id="sidenav-left-companies"
                [matTooltip]="'COMPANY.PLURAL' | translate"
                [matTooltipPosition]="'right'"
                [matTooltipDisabled]="!isLeftMenuCollapsed"
                [queryParamsHandling]="'preserve'"
                [routerLink]="['/companies/']"
                [routerLinkActive]="'active'"
              >
                <div class="menu-item__content">
                  <mat-icon class="i20 menu-item__content__icon">business</mat-icon>
                  <span class="menu-item__content__label" [translate]="'COMPANY.PLURAL'"></span>
                </div>
              </a>

              <a
                class="menu-item"
                matRipple
                [matRippleUnbounded]="true"
                [matRippleCentered]="true"
                id="sidenav-left-vacancies"
                [matTooltip]="'LAYOUT.NAVIGATION.VACANCY' | translate"
                [matTooltipPosition]="'right'"
                [matTooltipDisabled]="!isLeftMenuCollapsed"
                [routerLink]="['/vacancies/']"
                [routerLinkActive]="'active'"
              >
                <div class="menu-item__content">
                  <mat-icon class="i20 menu-item__content__icon">find_in_page</mat-icon>
                  <span
                    class="menu-item__content__label"
                    [translate]="'LAYOUT.NAVIGATION.VACANCY'"
                  ></span>
                </div>
              </a>

              <a
                class="menu-item"
                matRipple
                [matRippleUnbounded]="true"
                [matRippleCentered]="true"
                id="sidenav-left-events"
                [matTooltip]="'EVENT.PLURAL' | translate"
                [matTooltipPosition]="'right'"
                [matTooltipDisabled]="!isLeftMenuCollapsed"
                [queryParamsHandling]="'preserve'"
                [routerLink]="['/events/']"
                [routerLinkActive]="'active'"
              >
                <div class="menu-item__content">
                  <mat-icon class="i20 menu-item__content__icon">history</mat-icon>
                  <span class="menu-item__content__label" [translate]="'EVENT.PLURAL'"></span>
                </div>
              </a>

              <mat-divider class="my-2"></mat-divider>

              <a
                class="menu-item"
                matRipple
                [matRippleUnbounded]="true"
                [matRippleCentered]="true"
                id="sidenav-left-search-assignments"
                [matTooltip]="'SEARCH_ASSIGNMENT.TITLE' | translate"
                [matTooltipPosition]="'right'"
                [matTooltipDisabled]="!isLeftMenuCollapsed"
                [routerLink]="['/search-assignments']"
                [routerLinkActive]="'active'"
              >
                <div class="menu-item__content">
                  <mat-icon class="i20 menu-item__content__icon">document</mat-icon>
                  <span
                    class="menu-item__content__label"
                    [translate]="'SEARCH_ASSIGNMENT.TITLE'"
                  ></span>
                </div>
              </a>

              <a
                class="menu-item"
                matRipple
                [matRippleUnbounded]="true"
                [matRippleCentered]="true"
                id="sidenav-left-allocations"
                [matTooltip]="'ALLOCATION.PLURAL' | translate"
                [matTooltipPosition]="'right'"
                [matTooltipDisabled]="!isLeftMenuCollapsed"
                [queryParamsHandling]="'preserve'"
                [routerLink]="['/allocations/']"
                [routerLinkActive]="'active'"
              >
                <div class="menu-item__content">
                  <mat-icon class="i20 menu-item__content__icon">handshake_o</mat-icon>
                  <span class="menu-item__content__label" [translate]="'ALLOCATION.PLURAL'"></span>
                </div>
              </a>

              <a
                [href]="brightStaffingUrl"
                target="_blank"
                id="sidenav-left-encodage"
                class="menu-item"
                matRipple
                [matRippleUnbounded]="true"
                [matRippleCentered]="true"
                [matTooltip]="'LAYOUT.NAVIGATION.TIMESHEETS' | translate"
                [matTooltipPosition]="'right'"
                [matTooltipDisabled]="!isLeftMenuCollapsed"
              >
                <div class="menu-item__content">
                  <mat-icon class="i20 menu-item__content__icon">timer</mat-icon>
                  <span
                    class="menu-item__content__label"
                    [translate]="'LAYOUT.NAVIGATION.TIMESHEETS'"
                  ></span>
                </div>
              </a>

              @if (isControlTowerItemVisible$ | async) {
                <mat-divider class="my-2"></mat-divider>

                <a
                  id="sidenav-left-watch-tower"
                  class="menu-item"
                  matRipple
                  [matRippleUnbounded]="true"
                  [matRippleCentered]="true"
                  [matTooltip]="'NAV_HISTORY.CONTROL_TOWER' | translate"
                  [matTooltipPosition]="'right'"
                  [matTooltipDisabled]="!isLeftMenuCollapsed"
                  [routerLink]="['/watch-tower/']"
                  [routerLinkActive]="'active'"
                >
                  <div class="menu-item__content">
                    <mat-icon
                      class="i20 menu-item__content__icon auto-width"
                      [matBadge]="controlTowerService.controlTowerBadgeCount$ | async"
                      matBadgeSize="small"
                      [matBadgeOverlap]="false"
                      matBadgePosition="before"
                    >
                      cell_tower
                    </mat-icon>
                    <span
                      class="menu-item__content__label"
                      [translate]="'NAV_HISTORY.CONTROL_TOWER'"
                    ></span>
                  </div>
                </a>
              }
              @if (isPowerBIDashboardEnabled()) {
                <mat-divider class="my-2"></mat-divider>
                <a
                  id="sidenav-left-power-bi-dashboard"
                  class="menu-item"
                  matRipple
                  [matRippleUnbounded]="true"
                  [matRippleCentered]="true"
                  [matTooltip]="'NAV_HISTORY.POWER_BI_DASHBOARD' | translate"
                  [matTooltipPosition]="'right'"
                  [matTooltipDisabled]="!isLeftMenuCollapsed"
                  [routerLink]="['/cockpit/']"
                  [routerLinkActive]="'active'"
                >
                  <div class="menu-item__content">
                    <mat-icon class="i20 menu-item__content__icon auto-width">
                      navigation
                    </mat-icon>
                    <span
                      class="menu-item__content__label"
                      [translate]="'NAV_HISTORY.POWER_BI_DASHBOARD'"
                    ></span>
                  </div>
                </a>
              }
            </div>
          </div>
        </div>
      </mat-sidenav>

      <mat-sidenav-content
        cdk-scrollable
        class="sidenav-content-container infinite-scroll-container"
        [ngClass]="{
          'sidenav-content-container--dev-environment':
            environmentTag !== 'prod' && environmentTag !== 'local',
        }"
      >
        <mat-toolbar color="primary" class="toolbar position-fixed p-0 shadow">
          <div class="toolbar-container d-flex flex-grow-1 h-100">
            <div class="row m-0 flex-grow-1">
              <div class="col-8 pl-4 d-flex align-items-center">
                @if (isRightMenuCollapsed) {
                  <wlnob-navigation-history></wlnob-navigation-history>
                }
              </div>

              <div class="col-2 px-4 d-flex align-items-center justify-content-center flex-column">
                @if (environmentTag !== 'prod' && environmentTag !== 'local') {
                  <div class="environment-label">{{ environmentTag }} environment</div>
                }
              </div>

              <div class="col-2 pl-4 pr-0 d-flex align-items-center justify-content-end">
                <wlnob-language-switch class="d-flex align-self-end"></wlnob-language-switch>
              </div>
            </div>
          </div>

          @if (isLoading$ | async) {
            <mat-progress-bar class="place-bottom" mode="indeterminate"></mat-progress-bar>
          }
        </mat-toolbar>

        <div class="sidenav-content container-fluid p-4 position-relative">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>

      <mat-sidenav class="sidenav-right" [mode]="'over'" [opened]="true" position="end">
        <div class="sidenav-full" id="sidenav-right">
          <div class="m-0 vh-100 flex-column overflow-hidden">
            <div
              class="sidenav-right__toggle d-flex flex-grow-0 align-items-center py-3 px-4"
              (click)="toggleRightMenu()"
            >
              <button mat-icon-button>
                @if (isRightMenuCollapsed) {
                  <mat-icon class="status">user</mat-icon>
                } @else {
                  <mat-icon>chevron_right</mat-icon>
                }
              </button>

              @if (!isRightMenuCollapsed) {
                <span class="flex-grow-1 text-right">
                  {{ currUser.user.firstName }} {{ currUser.user.lastName }}
                </span>

                <button class="sidenav-right__toggle__logout" mat-icon-button (click)="logout()">
                  <mat-icon>logout</mat-icon>
                </button>
              }
            </div>

            <div
              class="sidenav-right__content flex-grow-1 overflow-auto"
              (click)="toggleRightMenu(true)"
            >
              <mat-accordion>
                <mat-expansion-panel [hideToggle]="isRightMenuCollapsed">
                  <mat-expansion-panel-header
                    [matTooltip]="'LAYOUT.ACTION_PANE.UNANSWERED_SMS.TITLE' | translate"
                    [matTooltipPosition]="'left'"
                    [matTooltipDisabled]="!isRightMenuCollapsed"
                  >
                    <mat-panel-title>
                      <div class="menu-item">
                        <div class="menu-item__icon">
                          <mat-icon
                            [matBadge]="numberOfUnansweredSMS"
                            [matBadgeDisabled]="!numberOfUnansweredSMS"
                            [matBadgeSize]="'small'"
                          >
                            sms
                          </mat-icon>
                        </div>
                        <div
                          class="menu-item__title"
                          [translate]="'LAYOUT.ACTION_PANE.UNANSWERED_SMS.TITLE'"
                        ></div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <wlnob-unanswered-sms-list
                    (unansweredSMS)="numberOfUnansweredSMS = $event || 0"
                  ></wlnob-unanswered-sms-list>
                </mat-expansion-panel>

                <mat-expansion-panel [hideToggle]="isRightMenuCollapsed">
                  <mat-expansion-panel-header
                    [matTooltip]="'LAYOUT.ACTION_PANE.ADD_COMPANY.TITLE' | translate"
                    [matTooltipPosition]="'left'"
                    [matTooltipDisabled]="!isRightMenuCollapsed"
                  >
                    <mat-panel-title>
                      <div class="menu-item">
                        <div class="menu-item__icon">
                          <mat-icon> business </mat-icon>
                        </div>
                        <div
                          class="menu-item__title"
                          [translate]="'LAYOUT.ACTION_PANE.ADD_COMPANY.TITLE'"
                        ></div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <wlnob-processing-company-list></wlnob-processing-company-list>
                </mat-expansion-panel>

                <mat-expansion-panel [hideToggle]="isRightMenuCollapsed">
                  <mat-expansion-panel-header
                    [matTooltip]="'LAYOUT.ACTION_PANE.APPROVAL_TO_WORK.TITLE' | translate"
                    [matTooltipPosition]="'left'"
                    [matTooltipDisabled]="!isRightMenuCollapsed"
                  >
                    <mat-panel-title>
                      <div class="menu-item menu-item__approval-to-work">
                        <div class="menu-item__icon">
                          <mat-icon
                            [matBadge]="numberOfApprovalToWorkAllocations"
                            [matBadgeDisabled]="!numberOfApprovalToWorkAllocations"
                            [matBadgeSize]="'small'"
                          >
                            verified_user
                          </mat-icon>
                        </div>
                        <div
                          class="menu-item__title"
                          [translate]="'LAYOUT.ACTION_PANE.APPROVAL_TO_WORK.TITLE'"
                        ></div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <wlnob-safety-allocation-list
                    [safetyStatuses]="[workApprovalStatusEnum.UNVERIFIED]"
                    (safetyAllocations)="numberOfApprovalToWorkAllocations = $event || 0"
                  ></wlnob-safety-allocation-list>
                </mat-expansion-panel>

                <mat-expansion-panel [hideToggle]="isRightMenuCollapsed">
                  <mat-expansion-panel-header
                    [matTooltip]="'LAYOUT.ACTION_PANE.MEDICAL_EXAMINATION.TITLE' | translate"
                    [matTooltipPosition]="'left'"
                    [matTooltipDisabled]="!isRightMenuCollapsed"
                  >
                    <mat-panel-title>
                      <div class="menu-item menu-item__safety-dispatch">
                        <div class="menu-item__icon">
                          <mat-icon
                            [matBadge]="numberOfSafetyDispatchAllocations"
                            [matBadgeDisabled]="!numberOfSafetyDispatchAllocations"
                            [matBadgeSize]="'small'"
                          >
                            verified_user
                          </mat-icon>
                        </div>
                        <div
                          class="menu-item__title"
                          [translate]="'LAYOUT.ACTION_PANE.MEDICAL_EXAMINATION.TITLE'"
                        ></div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <wlnob-safety-allocation-list
                    [safetyStatuses]="[workApprovalStatusEnum.MEDICAL_EXAMINATION]"
                    (safetyAllocations)="numberOfSafetyDispatchAllocations = $event || 0"
                  ></wlnob-safety-allocation-list>
                </mat-expansion-panel>

                <mat-expansion-panel [hideToggle]="isRightMenuCollapsed">
                  <mat-expansion-panel-header
                    [matTooltip]="'LAYOUT.ACTION_PANE.CONDITIONAL_APPROVED.TITLE' | translate"
                    [matTooltipPosition]="'left'"
                    [matTooltipDisabled]="!isRightMenuCollapsed"
                  >
                    <mat-panel-title>
                      <div class="menu-item menu-item__conditional-approved">
                        <div class="menu-item__icon">
                          <mat-icon
                            [matBadge]="numberOfConditionalApprovedAllocations"
                            [matBadgeDisabled]="!numberOfConditionalApprovedAllocations"
                            [matBadgeSize]="'small'"
                          >
                            verified_user
                          </mat-icon>
                        </div>
                        <div
                          class="menu-item__title"
                          [translate]="'LAYOUT.ACTION_PANE.CONDITIONAL_APPROVED.TITLE'"
                        ></div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <wlnob-safety-allocation-list
                    [safetyStatuses]="[workApprovalStatusEnum.CONDITIONAL_APPROVED]"
                    (safetyAllocations)="numberOfConditionalApprovedAllocations = $event || 0"
                  ></wlnob-safety-allocation-list>
                </mat-expansion-panel>

                <mat-expansion-panel [hideToggle]="isRightMenuCollapsed">
                  <mat-expansion-panel-header
                    [matTooltip]="
                      'LAYOUT.ACTION_PANE.DIGIDOCS_MISSING_SIGNATURES.TITLE' | translate
                    "
                    [matTooltipPosition]="'left'"
                    [matTooltipDisabled]="!isRightMenuCollapsed"
                  >
                    <mat-panel-title>
                      <div class="menu-item menu-item__digidocs">
                        <div class="menu-item__icon">
                          <mat-icon
                            [matBadge]="missingSignaturesDigidocsTotalCount$ | async"
                            [matBadgeDisabled]="!(missingSignaturesDigidocsTotalCount$ | async)"
                            [matBadgeSize]="'small'"
                          >
                            document
                          </mat-icon>
                        </div>
                        <div
                          class="menu-item__title"
                          [translate]="'LAYOUT.ACTION_PANE.DIGIDOCS_MISSING_SIGNATURES.TITLE'"
                        ></div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <ng-template matExpansionPanelContent>
                    <mat-table
                      style="max-height: 300px"
                      [dataSource]="missingSignatureDigidocs$ | async"
                      class="overflow-auto"
                    >
                      <ng-container matColumnDef="deadline">
                        <mat-cell *matCellDef="let row">
                          {{ row.deadline | dateTimeTransform | async }}
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef>
                          <ng-container [ngTemplateOutlet]="rowCellSkeleton"></ng-container>
                        </mat-footer-cell>
                      </ng-container>

                      <ng-container matColumnDef="employee">
                        <mat-cell *matCellDef="let row">
                          {{ row.employee?.fullName }}
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef>
                          <ng-container [ngTemplateOutlet]="rowCellSkeleton"></ng-container>
                        </mat-footer-cell>
                      </ng-container>

                      <ng-container matColumnDef="company">
                        <mat-cell *matCellDef="let row">
                          {{ row.company.name }}
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef>
                          <ng-container [ngTemplateOutlet]="rowCellSkeleton"></ng-container>
                        </mat-footer-cell>
                      </ng-container>

                      <ng-container matColumnDef="function">
                        <mat-cell *matCellDef="let row">
                          {{ row.function }}
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef>
                          <ng-container [ngTemplateOutlet]="rowCellSkeleton"></ng-container>
                        </mat-footer-cell>
                      </ng-container>

                      <ng-template matNoDataRow>
                        <div class="text-center p-5">
                          {{ 'LABELS.NO_RESULTS' | translate }}
                        </div>
                      </ng-template>

                      <mat-row
                        *matRowDef="let row; columns: missingSignaturesTableColumns"
                        class="cursor-pointer"
                        (click)="navigateToAllocation(row); $event.stopPropagation()"
                      ></mat-row>
                      <mat-footer-row
                        *matFooterRowDef="missingSignaturesTableColumns"
                        class="h-auto pt-3"
                        [hidden]="!!(missingSignatureDigidocs$ | async)"
                      >
                      </mat-footer-row>
                    </mat-table>
                  </ng-template>
                </mat-expansion-panel>

                <mat-expansion-panel [hideToggle]="isRightMenuCollapsed">
                  <mat-expansion-panel-header
                    [matTooltip]="'LAYOUT.ACTION_PANE.SUPPORT.TITLE' | translate"
                    [matTooltipPosition]="'left'"
                    [matTooltipDisabled]="!isRightMenuCollapsed"
                  >
                    <mat-panel-title>
                      <div class="menu-item menu-item__help-center">
                        <div class="menu-item__icon">
                          <mat-icon>contact_support</mat-icon>
                        </div>
                        <div
                          class="menu-item__title"
                          [translate]="'LAYOUT.ACTION_PANE.SUPPORT.TITLE'"
                        ></div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <p class="e-learning">
                    <a
                      href="https://achares.sharepoint.com/sites/boemm/SitePages/E-learning.aspx"
                      target="_blank"
                    >
                      {{ 'LAYOUT.ACTION_PANE.SUPPORT.E-LEARNING' | translate }}
                      <mat-icon>external_link</mat-icon>
                    </a>
                  </p>

                  <p>
                    {{ 'LAYOUT.ACTION_PANE.SUPPORT.CONTACT_SALES_ADMIN' | translate }}
                    <strong>sales admin</strong>
                    <wlnob-contact-button
                      [type]="contactTypeEnum.SALES_ADMIN"
                    ></wlnob-contact-button>
                  </p>

                  <p>
                    {{ 'LAYOUT.ACTION_PANE.SUPPORT.CONTACT_ICT_SUPPORT' | translate }}
                    <strong>ICT support</strong>
                    <wlnob-contact-button
                      [type]="contactTypeEnum.ICT_SUPPORT"
                    ></wlnob-contact-button>
                  </p>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
        </div>
      </mat-sidenav>
    </mat-sidenav-container>
  </div>

  <div class="min-width-overlay">{{ 'LAYOUT.MIN_VIEW_WIDTH.CONTENT' | translate }}</div>
} @else {
  <div class="authenticating">
    <p>Inloggen...</p>
  </div>
}

<ng-template #rowCellSkeleton>
  <ngx-skeleton-loader class="w-100" count="5"></ngx-skeleton-loader>
</ng-template>
